export default "__VITE_ASSET__kXmwAgQm__"